const hasCustomDateRange = (value: string) => {
  if (value.includes('Custom Date Range')) {
    if (value?.split('-').length > 1) return true;
  }
  return false;
};

export default hasCustomDateRange;
